<template>
  <div class="my-container">
    <v-card class="content-card mx-auto mb-10">
      <v-card-text class="content-wrapper">
        <div class="find-text size-18 weight8">
          Über uns
        </div>
        <div class="mt-4">
          Volt.Land befindet sich aktuell in der Testphase. Um besser zu verstehen, welche Modelle euch interessieren bewerben wir für einen kurzen, begrenzten Zeitraum unser Angebot. Es ist also noch nicht möglich ein Auto zu bestellen - Preise sind somit nicht repräsentativ. Dies machen wir nur, um euer Feedback einzusammeln und somit lernen und besser einschätzen können wie ihr unsere Seite nutzt. Das hilft uns bei der letztendlichen Fertigstellung unseres Angebotes. Ich hoffe ihr habt Verständnis und unterstützt unser einzigartiges Elektroauto-Angebot. Vielen Dank. Euer Volt.Land Team.
        </div>
        <div class="mt-4">
          Volt.land ist die erste reine Plattform für die innovative, auf künstlicher Intelligenz basierte Online-Direktbestellung von vorkonfigurierten und sofort verfügbaren Elektroautos mit Lieferung bis zur Haustür - wie Produkte bei Amazon bestellen - schnell, einfach und stressfrei.
        </div>
        <div class="mt-4">
          Unsere Mission ist die Art und Weise zu ändern wie wir Elektro-Neuwagen finden, aussuchen und bestellen.
        </div>
        <div class="mt-4">
          Wir bieten Kunden ein neues, vollständig digitales Online-Bestellerlebnis nur für Elektroautos mit transparenten Preisen, ohne versteckte Kosten, kein Händlerstress und mit einer emotionalen Lieferung bis nach Hause.
        </div>
        <div class="mt-4">
          Heutzutage ist es sehr schwierig, Elektroautos direkt online herstellerübergreifend zu finden und zu bestellen - Verbraucher müssen immer noch Informationen über verschiedene Händler-Webseiten sammeln. Der übliche Weg ist immer noch, Händler zu besuchen und mit ihnen zu verhandeln und dann bis zu 6 Monate auf ein Auto zu warten, was viel Aufwand und Zeit bedeutet. Bis heute ist es noch nicht möglich, die gesamte Transaktion der Online-Bestellung von Autos herstellerübergreifend durchzuführen und es nach Hause liefern zu lassen (Amazon-Erfahrung). Und gerade für Elektroautos gibt es solche digitalen Konzepte nicht.
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'about'
}
</script>

<style lang="scss" scoped>
.my-container {
  background-image: url('~@/assets/img/background3.png');
  background-size: contain;
  padding-top: 110px;
  min-height: 80vh;

  .content-card {
    width: 90%;
    padding: 43px 24px;
    border-radius: 15px !important;

    .content-wrapper {
      padding: 0;
      color: #020B2D;
    }
  }
}
</style>